import { FilterMatchMode } from "primereact/api"

export class Criterio {
    model = {
        id: { value: null, export: false },
        nombre: {
            value: '', export: true, header: 'Nombre', required: 'Campo requerido', table: true, maxLength: 'Máximo 300 caracteres',
            filterPlaceholder: 'Búsqueda', minLength: 'Mínimo 3 caracteres', max: 300, min: 4, filterField: 'nombre', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS
        },
    }

    optionLabel = 'tipo_adjunto'
}
